import { Slot } from '@radix-ui/react-slot'
import * as React from 'react'
import { cn } from '../lib/utils'
import { Badge } from './ui/badge'

export interface StarshipIconProps extends React.HTMLAttributes<HTMLSpanElement> {}

export const StarshipIcon = React.memo(function StarshipIcon({
  className = 'h-6 w-6 shrink-0',
  ...props
}: StarshipIconProps) {
  return (
    <span aria-hidden="true" className={cn('relative inline-block shrink-0', className)} {...props}>
      <img
        src="/icon.png"
        alt=""
        className="block h-full w-full object-contain dark:hidden"
        draggable={false}
      />
      <img
        src="/icon-dark.png"
        alt=""
        className="hidden h-full w-full object-contain dark:block"
        draggable={false}
      />
    </span>
  )
})

type LogoProps = StarshipIconProps

export const Logo = React.memo(function Logo({ className, ...props }: LogoProps) {
  return <StarshipIcon className={className} {...props} />
})

type NavLogoProps = React.HTMLAttributes<HTMLDivElement> & {
  asChild?: boolean
  showBadge?: boolean
  badgeText?: string
  brandName?: string
}

export const NavLogo = React.memo(function NavLogo({
  className,
  asChild,
  showBadge = true,
  badgeText = 'Scheduling',
  brandName = 'Zippity',
  ...props
}: NavLogoProps) {
  const Comp = asChild ? Slot : 'div'

  return (
    <Comp className={cn('flex items-center gap-2', className)} {...props}>
      <Logo className="h-6 w-6" />
      <span className="text-lg font-semibold tracking-tight">{brandName}</span>
      {showBadge && (
        <Badge variant="secondary" className="px-1.5 py-0.5 text-[10px] leading-none">
          {badgeText}
        </Badge>
      )}
    </Comp>
  )
})
